import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ breakpoints, palette }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    background: palette.neutral[900],
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: rem(24),
    gap: 2,
  },
  link: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: 'unset',
    },
  },
  helpLinkTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: rem(12),
    width: '100%',
  },
  helpLink: {
    backgroundColor: palette.common.white,
    padding: rem(24),
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: rem(20),
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  topHelp: {
    borderTopLeftRadius: rem(12),
    borderTopRightRadius: rem(12),
  },
  bottomHelp: {
    borderBottomLeftRadius: rem(12),
    borderBottomRightRadius: rem(12),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 2,
  },
  textSecondary: {
    color: palette.text.secondary,
    textAlign: 'initial',
  },
  mainContent: {
    padding: rem(16),
    flex: 1,
    [breakpoints.up('lg')]: {
      marginLeft: rem(80),
    },
  },
  mainImage: {
    right: 0,
    flex: 1.3,
    height: rem(560),
  },
  image: {
    height: '100%',
    position: 'relative',
    objectFit: 'cover',
  },
  gradientRectangle: {
    zIndex: 1,
    position: 'absolute',
    width: '300px',
    height: '100%',
    left: 0,
    top: 0,
    background: `linear-gradient(90deg, ${palette.neutral[900]} 0%, rgba(244, 244, 245, 0) 100%)`,
  },
}));
